import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/x-close.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M17.293 5.29289C17.6835 4.90237 18.3165 4.90237 18.707 5.29289C19.0975 5.68342 19.0975 6.31643 18.707 6.70696L13.414 11.9999L18.707 17.2929L18.7754 17.3691C19.0957 17.7618 19.0731 18.3408 18.707 18.707C18.3409 19.0731 17.7619 19.0957 17.3691 18.7753L17.293 18.707L12 13.414L6.70702 18.707C6.31649 19.0975 5.68348 19.0975 5.29295 18.707C4.90243 18.3164 4.90243 17.6834 5.29295 17.2929L10.5859 11.9999L5.29295 6.70696C4.90243 6.31643 4.90243 5.68342 5.29295 5.29289C5.68348 4.90237 6.31649 4.90237 6.70702 5.29289L12 10.5859L17.293 5.29289Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as XCloseIcon };
